import React from "react";
import Icon from "./Icon";
import { ICONS, PAGINATION_BUTTONS } from "../../constants/enums";

const Pagination = ({ totalCount, currentPage, itemsPerPage, updateCurrentPage }: { totalCount: number, currentPage: number, itemsPerPage: number, updateCurrentPage: (newPageNumber: number) => void }) => {
  const totalPages = Math.ceil(totalCount / itemsPerPage);
  const isOnFirstPage = currentPage === 1;
  const isOnLastPage = currentPage === totalPages;

  const firstIcon = isOnFirstPage ? ICONS.CHEVRON_FIRST_DISABLED : ICONS.CHEVRON_FIRST;
  const previousIcon = isOnFirstPage ? ICONS.CHEVRON_PREVIOUS_DISABLED : ICONS.CHEVRON_PREVIOUS;
  const nextIcon = isOnLastPage ? ICONS.CHEVRON_NEXT_DISABLED : ICONS.CHEVRON_NEXT;
  const lastIcon = isOnLastPage ? ICONS.CHEVRON_LAST_DISABLED : ICONS.CHEVRON_LAST;

  const renderPageButtons = () => {
    const pageButtons: JSX.Element[] = [];

    for (let i = 1; i <= totalPages; i++) {
      pageButtons.push(
        <li key={i}>
          <button className={`no-styling ${i === currentPage ? 'active' : ''}`} onClick={() => updateCurrentPage(i)}>
            {i}
          </button>
        </li>
      );
    }

    return pageButtons;
  }

  const handleClick = (button: number) => {
    if ((button === PAGINATION_BUTTONS.FIRST || button === PAGINATION_BUTTONS.PREV) && isOnFirstPage) {
      return;
    }

    if ((button === PAGINATION_BUTTONS.LAST || button === PAGINATION_BUTTONS.NEXT) && isOnLastPage) {
      return;
    }

    switch (button) {
      case PAGINATION_BUTTONS.FIRST:
        updateCurrentPage(1);
        break;
      case PAGINATION_BUTTONS.PREV:
        updateCurrentPage(currentPage - 1);
        break;
      case PAGINATION_BUTTONS.NEXT:
        updateCurrentPage(currentPage + 1);
        break;
      case PAGINATION_BUTTONS.LAST:
        updateCurrentPage(totalPages);
        break;
    }

  }

  return (
    <nav className="pagination-container spacing-top-medium">
      <ul className="pagination">
        <li>
          <button className="no-styling" onClick={() => handleClick(PAGINATION_BUTTONS.FIRST)}>
            <Icon icon={firstIcon} />
          </button>
        </li>
        <li>
          <button className="no-styling" onClick={() => handleClick(PAGINATION_BUTTONS.PREV)}>
            <Icon icon={previousIcon} />
          </button>
        </li>

        {renderPageButtons()}

        <li>
          <button className="no-styling" onClick={() => handleClick(PAGINATION_BUTTONS.NEXT)}>
            <Icon icon={nextIcon} />
          </button>
        </li>
        <li>
          <button className="no-styling" onClick={() => handleClick(PAGINATION_BUTTONS.LAST)}>
            <Icon icon={lastIcon} />
          </button>
        </li>
      </ul>
    </nav>

  );
}

export default Pagination;